import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { CnpjUtils } from '../../shared/utils/cnpj-utils';

@Directive({
  selector: '[appCnpjAlphanumericValidator][formControlName],[appCnpjAlphanumericValidator][formControl],[appCnpjAlphanumericValidator][ngModel]',
  providers: [
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CnpjAlphanumericValidatorDirective),
    },
  ],
})
export class CnpjAlphanumericValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } | null {
    const value = control?.value;
    if (!value) return null;

    if (!CnpjUtils.isValidWithCheckDigits(value)) {
      return { cnpjCheck: true, message: 'CNPJ inválido' };
    }

    return null;
  }
}
